export default __webpack_public_path__ + "static/media/greeting21.5136345b.png";